import * as effects from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import * as actions from './actions'
import * as api from './api'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'

function* fetchLessons(payload: { id: string }): SagaIterator {
  try {
    const lessons = yield effects.call(api.fetchLessonsList, payload.id)
    yield effects.put(actions.fetchLessonsListSuccess(lessons.data))
  } catch (error) {
    console.warn('Cannot fetch lessons list', error)
    yield effects.put(
      actions.fetchLessonsListFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* removeLesson(payload: {
  id: string
  lessonId: string
}): SagaIterator {
  try {
    const { id, lessonId } = payload
    yield effects.call(api.removeLesson, lessonId)
    yield effects.put(actions.removeLessonSuccess())
    yield effects.put(actions.fetchLessonsList(id))
  } catch (error) {
    console.warn('Cannot remove lesson', error)
    yield effects.put(actions.removeLessonFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* watchFetchLessons(): SagaIterator {
  yield effects.takeEvery(actions.fetchLessonsList.toString(), fetchLessons)
}

function* watchRemoveLesson(): SagaIterator {
  yield effects.takeEvery(actions.removeLesson.toString(), removeLesson)
}

export default function* watchAdminLessons(): SagaIterator {
  yield effects.all([
    effects.fork(watchFetchLessons),
    effects.fork(watchRemoveLesson),
  ])
}
